import { QueryClient } from '@tanstack/react-query';
import { message } from 'antd';
import { deleteToken } from 'utils/auth';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error: any) => {
        // Don't retry on 401/403
        if (error?.status === 401 || error?.status === 403) {
          return false;
        }
        return failureCount < 3;
      },
      refetchOnWindowFocus: false,
      onError: (error: any, query: any) => {
        // Suppress error toasts if meta.suppressErrorToast is set
        if (query?.meta?.suppressErrorToast) {
          return;
        }

        const status = error?.status;

        // Don't show toast for auth errors (handled by redirect)
        if (status === 401 || status === 403) {
          return;
        }

        // Optionally show error toast for other query errors
        // Uncomment if you want global error toasts for queries:
        // const errorMessage = error?.message || error?.error || 'Request failed';
        // message.error(errorMessage);
      },
    },
    mutations: {
      onError: (error: any) => {
        const status = error?.status;

        if (status === 401) {
          deleteToken();
          window.location.assign(
            `/login?url=${encodeURIComponent(window.location.pathname)}`
          );
          return;
        }

        if (status === 403) {
          window.location.assign(
            `/permission?url=${encodeURIComponent(window.location.pathname)}`
          );
          return;
        }

        const errorMessage =
          error?.message || error?.error || 'Request failed';
        message.error(errorMessage);
      },
    },
  },
});
